import { render, staticRenderFns } from "./DenouncedUsersReport.vue?vue&type=template&id=2019d098&scoped=true&"
import script from "./DenouncedUsersReport.vue?vue&type=script&lang=js&"
export * from "./DenouncedUsersReport.vue?vue&type=script&lang=js&"
import style0 from "./DenouncedUsersReport.vue?vue&type=style&index=0&id=2019d098&scoped=true&lang=css&"
import style1 from "./DenouncedUsersReport.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2019d098",
  null
  
)

export default component.exports